var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRocketInPricing = function SvgIconRocketInPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconRocketInPricing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#iconRocketInPricing_svg__b)",
    d: "M3.504 15.879a.704.704 0 0 0 .13.812l.173.172a30.774 30.774 0 0 1 1.778-1.93c.05-.049.1-.073.15-.119L4.63 13.708c-.643 1.163-1.018 1.958-1.125 2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#iconRocketInPricing_svg__c)",
    d: "M9.562 18.911a32.033 32.033 0 0 1-1.926 1.781l.232.233a.703.703 0 0 0 .82.128c.363-.187.936-.457 2.152-1.134l-1.158-1.158c-.046.05-.07.1-.12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#iconRocketInPricing_svg__d)",
    d: "M9.187 15.31c-.508-.509-1.937-.053-2.608.618-2.246 2.245-3.26 3.837-3.715 4.777a.703.703 0 0 0 .94.94c.919-.447 2.491-1.456 4.764-3.729.738-.738 1.102-2.124.62-2.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#iconRocketInPricing_svg__e)",
    d: "M2.195 9.862.206 11.85a.703.703 0 0 0 .68 1.176c1.074-.288 2.02-.41 2.656-.247a37.737 37.737 0 0 1 2.911-4.44c-.596-.382-2.567-.17-4.258 1.522Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#iconRocketInPricing_svg__f)",
    d: "M11.901 24.425c.271.137.6.084.813-.13l1.99-1.99c1.54-1.54 1.81-3.526 1.46-4.157a40.117 40.117 0 0 1-4.443 2.889c.098.553.033 1.09-.199 2.657a.702.702 0 0 0 .38.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#iconRocketInPricing_svg__g)",
    d: "M13.96 7.553a2.112 2.112 0 0 0 0 2.983c.822.823 2.16.823 2.983 0a2.112 2.112 0 0 0 0-2.983 2.112 2.112 0 0 0-2.984 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#iconRocketInPricing_svg__h)",
    d: "M23.959 1.186a.702.702 0 0 0-.65-.649c-1.726-.13-3.446.083-5.132.598.127 1.159.726 2.412 1.749 3.435 1.035 1.035 2.322 1.634 3.501 1.746.454-1.591.67-3.296.532-5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#iconRocketInPricing_svg__i)",
    d: "M18.931 5.565c-1.17-1.17-1.884-2.574-2.113-3.94C12.595 3.357 8.554 7.138 5.36 12.45l1.586 1.587c1.085-.44 2.4-.556 3.236.278.835.836.717 2.152.277 3.235l1.639 1.639c4.087-2.464 8.846-6.345 10.87-11.508-1.4-.211-2.848-.927-4.037-2.116Zm-.994 5.966a3.52 3.52 0 0 1-4.972 0 3.52 3.52 0 0 1 0-4.972 3.52 3.52 0 0 1 4.972 0 3.52 3.52 0 0 1 0 4.972Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconRocketInPricing_svg__b",
    x1: 3.429,
    x2: 5.735,
    y1: 15.286,
    y2: 15.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconRocketInPricing_svg__c",
    x1: 7.636,
    x2: 10.84,
    y1: 19.946,
    y2: 19.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconRocketInPricing_svg__d",
    x1: 2.793,
    x2: 9.406,
    y1: 18.403,
    y2: 18.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconRocketInPricing_svg__e",
    x1: 0,
    x2: 6.453,
    y1: 10.614,
    y2: 10.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconRocketInPricing_svg__f",
    x1: 11.514,
    x2: 16.3,
    y1: 21.324,
    y2: 21.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconRocketInPricing_svg__g",
    x1: 13.343,
    x2: 17.56,
    y1: 9.045,
    y2: 9.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconRocketInPricing_svg__h",
    x1: 18.177,
    x2: 24,
    y1: 3.408,
    y2: 3.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconRocketInPricing_svg__i",
    x1: 5.36,
    x2: 22.967,
    y1: 10.407,
    y2: 10.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iconRocketInPricing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgIconRocketInPricing;